export default __webpack_public_path__ + "alberta-new.62eef1849bc11685dbd3.svg";